/*
Item: Meta data display and edit form
Name: MetaData
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MultiLanguage } from '../utils/MultiLanguage';
import MessageService from '../service/MessageService';
import { DropdownLabeled } from '../components/DropdownLabeled';
import { OverlayPanel } from 'primereact/overlaypanel';

const info = [
  {
    character: '*',
    description: 'Entspricht einer beliebigen Anzahl von Zeichen. Sie können das Sternchen (*) überall in einer Zeichenkette verwenden.',
    example: 'M*er findet Müller, Miller, Maler und Meister, aber nicht Motor oder Meyr',
  },
  {
    character: '?',
    description: 'Entspricht einem einzelnen Zeichen an einer bestimmten Stelle.',
    example: 'B?ll findet Ball, Bell und Bill',
  },
];

export default class MetaData extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      callerByTabIndex: {},
      pageByTabIndex: {},
      rowsPerPageOptions: [100, 200, 500, 1000],
      sortOrder: -1,
      expandedRows: null,
      eReturnMessages: [],
      activeIndexTab: 0,
      deleteList: [],
      // counter: 0,
      visible: false,
      shortLanguage: 'de',
      statisticsList: '',
      // menu: [],
      eLines: [],
      eProperties: [],
      jsonProperties: {
        properties: [
          {
            entry: [
              {
                label: 'Kurzname', // Beschriftung
                source: 'name', // Quelle
                path: '', // Pfad in JSON
                disabled: true, // editierbar?
                multilanguage: false, // Mehrsprachiger Eintrag
              },
              {
                label: 'Name der Datensatzbeschreibung',
                source: 'langText',
                path: '',
                disabled: false,
                multilanguage: true,
              },
            ],
          },
          {
            entry: [
              {
                label: 'Feldname',
                source: 'name',
                path: '',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'Merkmalsname',
                source: 'variableName',
                path: '',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'Beschreibung',
                source: 'langText',
                path: 'variableReference',
                disabled: true,
                multilanguage: true,
              },
              {
                label: 'Langtext',
                source: 'longtext',
                path: 'variableReference',
                disabled: true,
                multilanguage: true,
              },
              {
                label: 'Definition',
                source: 'definition',
                path: '',
                disabled: true,
                multilanguage: false,
              },
            ],
          },
          {
            entry: [
              {
                label: 'Name',
                source: 'name',
                path: '',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'Beschreibung',
                source: 'langText',
                path: 'variableReference',
                disabled: true,
                multilanguage: false,
              },
            ],
          },
          {
            entry: [
              {
                label: 'Fachschlüssel',
                source: 'value',
                path: '',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'Beschreibung',
                source: 'langText',
                path: 'valueReference',
                disabled: true,
                multilanguage: true,
              },
              {
                label: 'Langtext',
                source: 'longtext',
                path: 'valueReference',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'Signatur',
                source: 'signature',
                path: '',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'Sortierschlüssel',
                source: 'classificationKey',
                path: 'valueReference',
                disabled: true,
                multilanguage: false,
              },
              {
                label: 'KMAZ',
                source: '',
                path: 'periods',
                disabled: true,
                multilanguage: false,
              },
            ],
          },
        ],
      },
      listItemsOnTab: [[]],
      listTabContents: [
        {
          headings: '',
          breadcrumbs: '',
          levels: '',
          discription: '',
          tab: 0,
        },
      ],
      listSelectedBreadcrumbs: [],
      listSelectedHeadings: [],
      listSelectedLevels: [],
    };
    this.messageService = new MessageService();
    this.multiLanguage = new MultiLanguage();
    this.viewProperties = this.viewProperties.bind(this);
    this.export = this.export.bind(this);
    this.getDataTimeout = null
  }

  // onLoad read current data
  componentDidMount = async () => {
    this.loadStatisticList();
  };

  async handleClick(i) {
    const { statisticsList } = this.state;
    this.setState({ visible: true });
    const thisDescription = this.multiLanguage.returnInLanguage(statisticsList[i], 'de');
    await this.loadRecordStructure(statisticsList[i].name, 0, false, thisDescription);
    this.setState({ visible: false, globalFilter: '', valueInputText: '' });
  }

  handleCloseDependent() {
    const listItemsOnTab = [...this.state.listItemsOnTab];
    const listTabContents = [...this.state.listTabContents];
    const listSelectedBreadcrumbs = [...this.state.listSelectedBreadcrumbs];
    const listSelectedHeadings = [...this.state.listSelectedHeadings];
    const listSelectedLevels = [...this.state.listSelectedLevels];

    for (let i = listItemsOnTab.length - 1; i > 0; i -= 1) {
      if (i > 0) {
        if (true) {
          // console.log(i);
          // console.log('handleCloseDependent1.4', listItemsOnTab);
          /*
          let listItemsOnTab1 = listItemsOnTab.splice(i, 1);
          let listTabContents1 = listTabContents.splice(i, 1);
          let listSelectedBreadcrumbs1 = listSelectedBreadcrumbs.splice(i, 1);
          let listSelectedHeadings1 = listSelectedHeadings.splice(i, 1);
          let listSelectedLevels1 = listSelectedLevels.splice(i, 1);
          let eLines1 = eLines.splice(i, 1);
          let eProperties1 = eProperties.splice(i, 1);
          */
        }
      }
    }

    // console.log('handleCloseDependent2', listItemsOnTab);

    this.setState({
      listItemsOnTab,
      listTabContents,
      listSelectedBreadcrumbs,
      listSelectedHeadings,
      listSelectedLevels,
    });
  }

  handleCancel() {
    this.setState({
      editVisible: false,
    });
  }

  async onSelectionChange(val, callMode, isSecondOption, clearFilter) {
    this.setState({ visible: true });
    this.setState({ selectedItem: val });
    const {callerByTabIndex} = this.state;
    callerByTabIndex[this.state.listSelectedHeadings.length + 1] = val
    this.setState({ callerByTabIndex })

    if (clearFilter) this.setState({ globalFilter: '', valueInputText: '' });

    await this.loadRecordStructure(val, callMode, isSecondOption);
    this.setState({ visible: false });
  }

  getLinkAndObject = (level) => {
  // getLinkAndObject(level) {
    const linkObject = { link: '', object: '' };
    if (level === 0) {
      // RECORD_STRUCTURE( 138 )
      linkObject.link = 'recordstructure';
      linkObject.object = 138;
    } else if (level === 1) {
      // DATAFIELD( 134 )
      linkObject.link = 'datafield';
      linkObject.object = 134;
    } else if (level === 2) {
      // VARIABLE( 3 )
      linkObject.link = 'coding';
      linkObject.object = 3;
    } else {
      // ASSOCIATION_CODING_VALUE_TO_CODING( 132 )
      linkObject.link = 'codingvalueassociation';
      linkObject.object = 132;
    }
    return linkObject;
  }

  handleSave = async (activendexTab) => { // do save properties triggered by button
    this.setState({ editVisible: false });
    const { activeIndexTab } = this.state;
    const { listItemsOnTab } = this.state;
    const { eLines } = this.state;
    const { level } = listItemsOnTab[activeIndexTab][eLines[activeIndexTab]]; // übergeben?
    const { jsonProperties } = this.state;
    let source = '';
    let path = '';
    let multilanguage = '';
    let newValue = '';
    const found = 0;
    const { eProperties } = this.state;
    const tmp = this.state.eReturnMessages[activeIndexTab];
    let n = 0;
    // über alle Werte in jsonProperties.properties[level].entry
    for (let i = 0; i < jsonProperties.properties[level].entry.length; i += 1) {
      if (!jsonProperties.properties[level].entry[i].disabled // wenn entry[i].disabled
        && jsonProperties.properties[level].entry[i].label !== "KMAZ") { 
        source = jsonProperties.properties[level].entry[i].source;
        path = jsonProperties.properties[level].entry[i].path;
        multilanguage = jsonProperties.properties[level].entry[i].multilanguage;
        newValue = eProperties[activeIndexTab][i];
        // Listenwert überschreiben mit Editierwert:
        listItemsOnTab[activeIndexTab][eLines[activeIndexTab]][source] = newValue;
        n = 0;
        if (path === '') {
          if (multilanguage) {
            if (tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[found].shortDescription.langText[n].sprachKennzeichen !== 'de') n = 1;
            tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[found].shortDescription.langText[n].text = newValue;
          } else {
            tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[found][source] = newValue;
          }
        } else if (multilanguage) {
          if (tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[found][path].shortDescription.langText[n].sprachKennzeichen !== 'de') n = 1;
          tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[found][path].shortDescription.langText[n].text = newValue;
        } else {
          tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[found][path][source] = newValue;
        }
      }
    }
    this.setState({ listItemsOnTab });
    const linkObject = this.getLinkAndObject(level);
    const { link } = linkObject;
    const ret = await this.messageService.postRecordStructureUpdate(tmp, link);
    if (ret[1] === 'error') {
      const detail = ret[0];
      this.growl.show({ severity: 'error', summary: 'Fehler', detail });
    } else {
      this.growl.show({ severity: 'success', summary: 'Speichern', detail: 'Eigenschaften wurden gespeichert.' });
    }
  }

  setItem(eProperties, value, i) {
    const { activeIndexTab } = this.state;
    eProperties[activeIndexTab][i] = value;
    this.setState({ eProperties });
  }

  returnSortField = (levels) => {
  // returnSortField(levels) {
    let sortField = 'name';
    if (levels === 1) sortField = 'position';
    return sortField;
  }

  dialogueList(level, properties, activeIndexTab) {
    // console.log("dialogueList", this.state.listTabContents[activeIndexTab].levels)
    let { levels } = this.state.listTabContents[activeIndexTab];
    if (levels === '') levels = 0;
    const { eProperties } = this.state;
    let source = '';
    // console.log("dialogueList", levels, properties, activeIndexTab)
    const ret = properties[levels].entry.map(
      (e, i) => {
        try {
          source = eProperties[this.state.activeIndexTab][i];
          // console.log("source", source)
        } catch {
          source = '';
        }
        if(e.label !== "KMAZ") {
          return (
            <div key={`div${i}`} className="p-col-12 pi-md-12">
              <p />
              <p />
              <span className="md-inputfield">
                <InputText disabled={e.disabled} id={'in'+i} value={source} onChange={(e) => this.setItem(eProperties, e.target.value, i)} />
                <label htmlFor={'in'+i}>
                  {e.label}
                  :
                </label>
              </span>
              <p />
              <p />
            </div>
          );
        }
        else {
          return null
        }
      },
    );
    return ret;
  }

  returnProperties(properties, level, eProperties) {
    // let tmp = 0;
    let source = '';
    if (level !== '') {
      const ret = properties[level].entry.map(
        (e, i) => {
          // tmp += 1;
          try {
            source = eProperties[this.state.activeIndexTab][i];
          } catch {
            source = '';
            if (e.label === 'KMAZ') source = [];
          }
          if (e.label === 'KMAZ') {
            return (
              <tr key={`${level}tr${i}`}>
                <td key={`${level}td${i}source`} colSpan="2">
                  <DataTable
                    header='Gültigkeitszeiträume'
                    value={source}
                    emptyMessage="Keine Einträge vorhanden"
                  >
                    <Column header="Gültig von" field="validFrom" />
                    <Column header="Gültig bis" field="validTo" />
                    <Column header="Beschreibung" body={(period) => this.multiLanguage.returnInLanguage(period, 'de')} />
                    <Column header="Sortierschlüssel" field="classificationKey" />
                  </DataTable>
                </td>
              </tr>
            );
          }

          return (
            <tr key={`${level}tr${i}`}>
              <td key={`${level}td${i}label`}>
                {e.label}
                :
              </td>
              <td key={`${level}td${i}source`}>{source}</td>
            </tr>
          );
        },
      );
      return ret;
    }
    return <tr />;
  }

  renderPropertiesExpand(properties, level, eProperties, activeSaveDisabled) {
    return (
      <Card
        title="Eigenschaften"
      >
        <div>
          <table>
            <tbody>
              {this.returnProperties(properties, level, eProperties)}
            </tbody>
          </table>
        </div>
        {sessionStorage.getItem('role') === 'GROUP_ADMIN'
          ? (
            <Button
              id={`edit${level.id}`}
              disabled={activeSaveDisabled}
              label="Bearbeiten"
              onClick={() => this.showEdit()}
              type="button"
              icon="pi pi-md-playlist-add"
              className="p-button-success"
              style={{ marginRight: '.5em' }}
            />
          )
          : <span />}
      </Card>
    );
  }

  actionTemplate(rowData) {
    const tooltip = this.returnTooltipText(rowData.level);
    return (
      <div>
        <div>
          {rowData.level === 0
            ? (
              <Button
                id="loadData"
                tooltip={tooltip}
                onClick={() => this.onSelectionChange(rowData, 0, false, true)}
                type="button"
                icon={rowData.level === 1 ? 'pi pi-md-playlist-add' : 'pi pi-md-chevron-right'}
                className="p-button-success"
                style={{ marginRight: '.5em' }}
              />
            )
            : ''}
          {rowData.level === 1
            ? (
              <Button
                id="loadData3"
                tooltip={rowData.coding === '' ? 'keine Verschlüsselungsdaten vorhanden' : 'Verschlüsselungsdaten laden'}
                onClick={() => this.onSelectionChange(rowData, 0, true, true)}
                type="button"
                icon="pi pi-md-vpn-key"
                className="p-button-success"
                style={{ marginRight: '.5em' }}
                disabled={rowData.coding === ''}
              />
            )
            : ''}
          {rowData.level === 2
            ? (
              <Button
                id="loadData3"
                tooltip="Codierung laden"
                onClick={() => this.onSelectionChange(rowData, 0, false, true)}
                type="button"
                icon="pi pi-md-settings-ethernet"
                className="p-button-success"
                style={{ marginRight: '.5em' }}
              />
            )
            : ''}
          {rowData.level === 99
            ? (
              <Button
                id="removeTabs"
                tooltip="abhängige Tabs schließen"
                onClick={() => this.handleCloseDependent(rowData)}
                type="button"
                icon="pi pi-md-close"
                className="p-button-danger"
                style={{ marginRight: '.5em' }}
              />
            )
            : ''}
        </div>
      </div>
    );
  }

  export() {
    // console.log("this.dt", this.dt)
    this.dt.exportCSV();
  }

  returnTooltipText(level) {
    let ret = 'Codierungen laden';
    if (level === 0) ret = 'Merkmale laden';
    if (level === 1) ret = 'Ausprägungen laden';
    return ret;
  }

  cardHeader() {
    return (
      <div>
        {this.state.activeIndexTab
          ? (
            <div style={{ width: '100%' }}>
              <Button
                id="close"
                className="p-button-secondary"
                tooltip="Reiter schließen"
                onClick={() => this.closeTab(false)}
                type="button"
                style={{ float: 'right', margin: '4px 4px 0 0' }}
                icon="pi pi-md-clear"
              />
            </div>
          )
          : ''}
      </div>
    );
  }

  closeTab() {
    const {
      listItemsOnTab, listTabContents, listSelectedBreadcrumbs,
      listSelectedHeadings, listSelectedLevels, eLines,
      eProperties, callerByTabIndex, pageByTabIndex: pageByTabIndex
    } = this.state;
    this.setState({ globalFilter: '', valueInputText: '' });
    let { activeIndexTab } = this.state;
    if (activeIndexTab) {
      const t1 = listItemsOnTab.splice(activeIndexTab, 1);
      const t2 = listTabContents.splice(activeIndexTab, 1);
      const t3 = listSelectedBreadcrumbs.splice(activeIndexTab, 1);
      const t4 = listSelectedHeadings.splice(activeIndexTab, 1);
      const t5 = listSelectedLevels.splice(activeIndexTab, 1);
      const t7 = eLines.splice(activeIndexTab, 1);
      const t8 = eProperties.splice(activeIndexTab, 1);

      delete callerByTabIndex[activeIndexTab]
      delete pageByTabIndex[activeIndexTab]
      if (activeIndexTab > 0) {
        activeIndexTab -= 1;
      } else {
        activeIndexTab = 0;
      }
      this.setState({
        activeIndexTab,
        callerByTabIndex,
        pageByTabIndex
      });
    }
  }

  async onPage(level, page, maxRowsPerPage, first, sortField="Name", sortOrder=1, filter="", searchCriterion) {

    const {callerByTabIndex, listTabContents, activeIndexTab, pageByTabIndex} = this.state;

    let type;
    let ttype;
    let objtype;
    let displayType;

    if (level === 0) {
      const { listItemsOnTab } = this.state;
      if (listItemsOnTab.length === 0) {
        this.setState({ listItemsOnTab: [[]] });
      }
      type = 'recordstructure';
      displayType = 'DSB';
      ttype = 'STATISTIC';
      objtype = 'RECORD_STRUCTURE';
    } else if (level === 1) {
      type = 'datafield';
      displayType = 'Datenfeld';
      ttype = 'RECORD_STRUCTURE';
      objtype = 'DATAFIELD';
    } else if (level === 2) {
      type = 'coding';
      displayType = 'Ausprägung';
      ttype = 'DATAFIELD';
      objtype = 'CODING';
    } else {
      type = 'codingvalueassociation';
      displayType = 'VAZ';
      ttype = 'CODING';
      objtype = 'ASSOCIATION_CODING_VALUE_TO_CODING';
    }

    
    const caller = callerByTabIndex[activeIndexTab + 1];
    let elementsData = await this.messageService.postRecordStructureDirectoryWithPagination(
      caller.key, level, type, ttype, objtype, undefined, caller.id, page, maxRowsPerPage, sortField, sortOrder > 0 ? "ASC" : "DESC", filter, searchCriterion?.value || this.columnDefinition[listTabContents[activeIndexTab].levels]?.[0].sortField
    );
   
    if (elementsData[1] && elementsData[1] === "error") {
      this.growl.show({
        severity: elementsData[1],
        summary: "Hinweis",
        detail: elementsData[0],
      });

      const { listItemsOnTab } = this.state;
      listItemsOnTab[activeIndexTab] = [];
      this.setState({ listItemsOnTab, loading: false });
    } else {
      const {entries, validPages, potentialSelectionEntrySize} = elementsData;
      pageByTabIndex[activeIndexTab] = {...pageByTabIndex[activeIndexTab], page, maxRowsPerPage, potentialSelectionEntrySize, validPages, first, sortField, sortOrder, filter};
      elementsData = entries;
      
      this.setState({validPages, potentialSelectionEntrySize, pageByTabIndex})

      const nodes = elementsData.map((entry, i) => {
        let { name } = entry;
        let shortDescription = "";
        let classificationKey = "";

        if (entry.shortDescription) {
          if (
            entry.shortDescription.langText[0].sprachKennzeichen ===
            this.state.shortLanguage
          ) {
            this.state.languagenumber = 0;
          } else {
            this.state.languagenumber = 1;
          }
          shortDescription =
            entry.shortDescription.langText[this.state.languagenumber].text;
        }

        if (entry.variableReference) {
          if (
            entry.variableReference.shortDescription.langText[0]
              .sprachKennzeichen === this.state.shortLanguage
          ) {
            this.state.languagenumber = 0;
          } else {
            this.state.languagenumber = 1;
          }
          shortDescription =
            entry.variableReference.shortDescription.langText[
              this.state.languagenumber
            ].text;
          if (level > 1) name = entry.variableReference.name;
        }

        if (entry.valueReference) {
          // ### hier name prüfen
          if (
            entry.valueReference.shortDescription.langText[0]
              .sprachKennzeichen === this.state.shortLanguage
          ) {
            this.state.languagenumber = 0;
          } else {
            this.state.languagenumber = 1;
          }
          // refName = entry.valueReference.name;
          shortDescription =
            entry.valueReference.shortDescription.langText[
              this.state.languagenumber
            ].text;
          if (level > 1) name = entry.valueReference.name;
          classificationKey = entry.valueReference.classificationKey;
        }
        console.log("LINE#0", entry);
        const {
          validityFrom,
          validityTo,
          position,
          value,
          coding,
          signature,
          variableName,
        } = entry;
        const nameKey = entry.name === "Temp" ? entry.value : entry.name;
        return {
          line: i,
          key: nameKey,
          id: entry.id,
          name,
          breadcrumb: `${caller.breadcrumb} ${entry.name}`,
          langText: shortDescription,
          validityFrom,
          validityTo,
          classificationKey,
          type: displayType,
          level,
          tabNumber: this.state.listSelectedHeadings.length,
          position,
          fId: value,
          coding,
          signature,
          sigkey: value,
          sortkey: coding,
          variableName,
          origin: caller.breadcrumb.split(" ")[0],
        };
      });

      const { listItemsOnTab } = this.state;
      listItemsOnTab[activeIndexTab] = nodes;
      this.setState({ listItemsOnTab, loading: false });
    }
  }

  async loadRecordStructure(
    callerInput, level, isSecondOption, thisDescription, type, displayType, ttype, objtype,
  ) {
    let caller = callerInput;
    // let origin = callerInput;
    let callerBreadcrumb = caller;
    let titleStart;
    const { id } = caller;
    if (caller.key) {
      level = caller.level + 1;
      thisDescription = caller.langText;
      callerBreadcrumb = caller.breadcrumb;
      // ref20200907 var callerEncryption = caller.variableName;
      caller = caller.key;
    }
    // ### Check here if selected tab content already exists
    const { listSelectedBreadcrumbs, pageByTabIndex: pageByTabIndex, rowsPerPageOptions } = this.state;
    const found = listSelectedBreadcrumbs.find(
      (element) => element === callerBreadcrumb,
    );
    if (found) {
      this.growl.show({ severity: 'info', summary: 'Hinweis', detail: `Die Daten für ${callerBreadcrumb} wurden bereits geladen.` });
    } else {
      const name = caller;
      if (level === 0) {
        const { listItemsOnTab } = this.state;
        if (listItemsOnTab.length === 0) {
          this.setState({ listItemsOnTab: [[]] });
        }
        type = 'recordstructure';
        displayType = 'DSB';
        ttype = 'STATISTIC';
        objtype = 'RECORD_STRUCTURE';
        titleStart = 'Datensatzbeschreibungen zu ';
      } else if (level === 1) {
        type = 'datafield';
        displayType = 'Datenfeld';
        ttype = 'RECORD_STRUCTURE';
        objtype = 'DATAFIELD';
        titleStart = 'Datenfelder zu ';
      } else if (level === 2) {
        type = 'coding';
        displayType = 'Ausprägung';
        ttype = 'DATAFIELD';
        objtype = 'CODING';
        titleStart = 'Verschlüsselungen zu ';
      } else {
        type = 'codingvalueassociation';
        displayType = 'VAZ';
        ttype = 'CODING';
        objtype = 'ASSOCIATION_CODING_VALUE_TO_CODING';
        titleStart = 'Codierung zur Verschlüsselung ';
      }
      let elementsData = await this.messageService.postRecordStructureDirectoryWithPagination(
        name, isSecondOption, type, ttype, objtype, undefined, id, 1, rowsPerPageOptions[0]
      );

      if (elementsData[1] && elementsData[1] === 'error') {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      } else {

        if(level !== 0) {
          const {entries, validPages, potentialSelectionEntrySize} = elementsData;
          elementsData = entries;
          pageByTabIndex[this.state.listSelectedHeadings.length] = {validPages, potentialSelectionEntrySize}
          this.setState({pageByTabIndex})
        }

        const { deleteList } = this.state;
        if (level === 0) {
          deleteList[this.state.listSelectedHeadings.length] = elementsData;
          this.setState({
            deleteList,
            elementsData,
          });
          if (elementsData.entrys) elementsData = elementsData.entrys;
        }
        // console.log('Check1', elementsData);
     
        this.growl.show({ severity: 'success', summary: 'Hinweis', detail: `Daten für ${caller} wurden geladen.` });
        const counter = this.state.listSelectedHeadings.length;
        // listTabContents
        const tmp1 = this.state.listTabContents;
        const showName = name;
        // if (level===2) showName=callerEncryption // Test für Wunsch des FB
        tmp1[counter] = {
          headings: titleStart + showName,
          breadcrumbs: callerBreadcrumb,
          levels: level,
          description: ` ${thisDescription}`,
          tab: counter,
        };
        this.setState({ listTabContents: tmp1 });
        this.state.listSelectedHeadings[counter] = name;
        this.state.listSelectedBreadcrumbs[counter] = callerBreadcrumb;
        this.state.listSelectedLevels[counter] = level;
        const nodes = elementsData.map((entry, i) => {
          let { name } = entry;
          // let refLangText = "";
          // let refName = "";
          // let refVarName = "";
          // let refVarLangText = "";
          let shortDescription = '';
          let classificationKey = '';

          if (entry.shortDescription) {
            if (entry.shortDescription.langText[0].sprachKennzeichen === this.state.shortLanguage) {
              this.state.languagenumber = 0;
            } else {
              this.state.languagenumber = 1;
            }
            shortDescription = entry.shortDescription.langText[this.state.languagenumber].text;
          }

          if (entry.variableReference) {
            if (entry.variableReference.shortDescription.langText[0].sprachKennzeichen
              === this.state.shortLanguage) {
              this.state.languagenumber = 0;
            } else {
              this.state.languagenumber = 1;
            }
            shortDescription = entry.variableReference.shortDescription.langText[
              this.state.languagenumber].text;
            if (level > 1) name = entry.variableReference.name;
            // console.log("variableReference", refVarLangText, refVarName)
          }

          if (entry.valueReference) {
            // ### hier name prüfen
            if (entry.valueReference.shortDescription.langText[0].sprachKennzeichen
              === this.state.shortLanguage) {
              this.state.languagenumber = 0;
            } else {
              this.state.languagenumber = 1;
            }
            // refName = entry.valueReference.name;
            shortDescription = entry.valueReference.shortDescription.langText[
              this.state.languagenumber].text;
            if (level > 1) name = entry.valueReference.name;
            classificationKey = entry.valueReference.classificationKey;
          }
          console.log('LINE#0', entry);
          const { 
            validityFrom, validityTo, position,
            value, coding, signature, variableName,
          } = entry;
          const nameKey = entry.name === 'Temp' ? entry.value : entry.name;
          return (
            {
              line: i,
              key: nameKey,
              id: entry.id,
              name,
              breadcrumb: `${callerBreadcrumb} ${entry.name}`,
              langText: shortDescription,
              validityFrom,
              validityTo,
              classificationKey,
              type: displayType,
              level,
              tabNumber: counter + 1,
              position,
              fId: value,
              coding,
              signature,
              sigkey: value,
              sortkey: coding,
              variableName,
              origin: callerBreadcrumb.split(' ')[0],
            }
          );
        });

        this.setState({ activeIndexTab: counter }); // set active tab to last tab
        const { listItemsOnTab } = this.state;
        listItemsOnTab[counter] = nodes //? nodes : [];
        // this.setState({ nodes });
        this.setState({ listItemsOnTab });
      }
    }
  }

  async loadStatisticList(returnMessage, statisticsList) {
    statisticsList = await this.messageService.postStatisticDirectory(returnMessage);
    // console.log('statisticsList', statisticsList);
    this.setState({
      statisticsList,
    });
  }

  async viewProperties(line) {
    const { activeIndexTab } = this.state;
    const { eProperties } = this.state;
    const { eLines } = this.state;
    eLines[activeIndexTab] = line.line;
    this.setState({ eLines });
    this.setState({ visible: true });
    const { level } = line;
    const linkObject = this.getLinkAndObject(level);
    const { link, object } = linkObject;
    let elementsData = await this.messageService.postRecordStructureProperties(
      line.id, object, link, false,
    );
    console.log('LINE#',line);
    const elementsDataLong = elementsData;
    elementsData = elementsData.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.entrys;
    if (elementsData?.[0]) {
      //KMAZ
      let kmaz;
      if (link === "codingvalueassociation") {
        kmaz = await this.messageService.postCodingValueassociationToKMAZ(elementsData[0]);
      }

      this.growl.show({ severity: 'info', summary: 'Eigenschaften', detail: `Eigenschaften für ${line.key} (${line.id}) wurden geladen.` });
      if (elementsData[1] && elementsData[1] === 'error') {
        // error during loading
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      } else {
        this.state.eReturnMessages[activeIndexTab] = elementsDataLong;
        const { properties } = this.state.jsonProperties;
        // variableReference
        // valueReference
        let value = '';
        const arr = [];
        let elPath = '';
        let elSource = '';
        for (let i = 0; i < properties[level].entry.length; i += 1) {
          let startNode = elementsData[0];
          elSource = properties[level].entry[i].source;
          elPath = properties[level].entry[i].path;
          // el ist the starting node
          if (elPath === 'valueReference') startNode = startNode.valueReference;
          if (elPath === 'variableReference') startNode = startNode.variableReference;
          if (elPath === 'periods' && kmaz) {
            value = kmaz[0]?.[elPath] || [];
          } else if (elSource === 'langText') {
            value = this.multiLanguage.returnInLanguage(startNode, 'de');
          } else if (elSource === 'longtext') {
            value = this.multiLanguage.returnLongInLanguage(startNode, 'de');
          } else {
            try {
              value = startNode[elSource];
            } catch {
              value = '';
            }
          }
          arr[i] = value;
        }
        eProperties[activeIndexTab] = arr;
        this.setState({
          eProperties,
        });
      }
    } else {
      this.growl.show({ severity: 'error', summary: 'Eigenschaften', detail: `Eigenschaften für ${line.key} (${line.id}) konnten nicht geladen werden.` });
    }
    this.setState({ visible: false });
  }

  returnTooltip = (el) => {
  // returnLongtext(el) {
    let ret;
    if (el.longtext) {
      ret = el.longtext.langText[0].text;
    }
    return ret;
  }

  showEdit() {
    this.setState({
      editVisible: true,
    });
  }

  columnDefinition = [
    [
      { field: 'name', width: '8em', header: 'Kurzname' }, // (0) Datensatzbeschreibungen - statistic (package of columns, here 2)
      { field: 'langText', width: '40em', header: 'Name der Datensatzbeschreibung' },
      {}, // buttons, length=0 means to render buttons from actionTemplate
    ],
    [
      { field: 'name', width: '8em', header: 'Feldname', sortField: 'Name', searchCriterion: 'Name' },
      { field: 'variableName', width: '8em', header: 'Merkmalsname', sortField: 'Merkmalsname', searchCriterion: 'Merkmalsname' },
      { field: 'langText', width: '20em', header: 'Beschreibung', sortField: 'Kurztext', searchCriterion:'Kurztext'},
      { field: 'position', width: '3em', header: 'Pos.', sortField: 'Positionsnummer' },
      {}, // buttons
    ],
    [
      { field: 'name', width: '8em', header: 'Name' }, // (2) Verschlüsselungen - encoding
      { field: 'langText', width: '16em', header: 'Beschreibung' },
      { field: 'validityFrom', width: '6em', header: 'gültig von' },
      { field: 'validityTo', width: '6em', header: 'gültig bis' },
      {}, // buttons
    ],
    [
      { field: 'name', width: '8em', header: 'Fachschlüssel', sortField: 'Fachschlüssel', searchCriterion:'Fachschlüssel' }, // (3) VAZ
      { field: 'langText', width: '16em', header: 'Beschreibung', sortField: 'Kurztext', searchCriterion:'Kurztext' },
      { field: 'signature', width: '6em', header: 'Signatur', sortField: 'Signatur' },
      { field: 'classificationKey', width: '10em', header: 'Sortierschlüssel', sortField: 'Klassifikationsschlüssel', searchCriterion:'Klassifikationsschlüssel' }
    ],
  ];

  renderMetaDataContentLines(level) {
    level = level === '' ? 0 : level; // without selected statistic level is empty and has to be set to 0

    /* const columnDefinition = [
      [
        { field: 'name', width: '8em', header: 'Kurzname', sortField: 'Name' }, // (0) Datensatzbeschreibungen - statistic (package of columns, here 2)
        { field: 'langText', width: '40em', header: 'Name der Datensatzbeschreibung' },
        {}, // buttons, length=0 means to render buttons from actionTemplate
      ],
      [
        { field: 'name', width: '8em', header: 'Feldname', sortField: 'Name' },
        { field: 'variableName', width: '8em', header: 'Merkmalsname' },
        { field: 'langText', width: '20em', header: 'Beschreibung' },
        { field: 'position', width: '3em', header: 'Pos.', sortField: 'Positionsnummer' },
        {}, // buttons
      ],
      [
        { field: 'name', width: '8em', header: 'Name', sortField: 'Name' }, // (2) Verschlüsselungen - encoding
        { field: 'langText', width: '16em', header: 'Beschreibung' },
        { field: 'validityFrom', width: '6em', header: 'gültig von' },
        { field: 'validityTo', width: '6em', header: 'gültig bis' },
        {}, // buttons
      ],
      [
        { field: 'name', width: '8em', header: 'Fachschlüssel', sortField: 'Fachschlüssel' }, // (3) VAZ
        { field: 'signature', width: '6em', header: 'Signatur' },
        { field: 'classificationKey', width: '10em', header: 'Sortierschlüssel' },
      ],
    ]; */

    let style = {};
    let st = '';
    const columns = this.columnDefinition[level].map(
      (e, i) => {
        if (i < this.columnDefinition[level].length - 1) {
          st = e.width;
          style = { width: st };
          return (
            <Column key={i} style={style} field={e.field} header={e.header} sortable={e.sortField && level > 0} sortField={e.sortField} />
          );
        }
        if (level === 0) {
          return (<Column key={i} header="Aktionen" body={(ex) => this.actionTemplate(ex, 0)} style={{ textAlign: 'center', width: '9em' }} />); // buttons
        } if (level === 3) {
          return (<Column key={i} style={style} field={e.field} header={e.header} sortable={e.sortField && level > 0} sortField={e.sortField} />);
        }
        return (<Column key={i} header="Aktionen" body={(ex) => this.actionTemplate(ex, 0)} style={{ textAlign: 'center', width: '5em' }} />);
      },
    );

    return [<Column expander style={{width: '3em'}}/>, ...columns];
  }

  renderMetaDataContent(statisticsList, listItemsOnTab, listTabContents) {
    const { activeIndexTab, jsonProperties, 
    loading, pageByTabIndex: pageByTabIndex, rowsPerPageOptions } = this.state;
    const { properties } = jsonProperties;
    const { eProperties } = this.state;
    let activeSaveDisabled = true;
    if (eProperties[activeIndexTab]) {
      activeSaveDisabled = false;
    }

    const header = (
      <div className="p-grid dashboard">
        <div className="p-col-10" style={{ textAlign: 'left' }}>
       {/*    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
          <InputText
            value={this.state.pageByTabIndex[activeIndexTab]?.filter}
            id="inputsearch"
            type="search"
            onInput={(e) => {
              console.log("columnDefinition",this.columnDefinition[listTabContents[activeIndexTab].levels].filter(col => col.sortField ).map(field => {return {name: field.sortField, value: field.sortField}}))
              pageByTabIndex[activeIndexTab] = { ...pageByTabIndex[activeIndexTab], filter: e.target.value } 
              this.setState({ pageByTabIndex, globalFilter: e.target.value, valueInputText: e.target.value })
              this.onPage(listTabContents[activeIndexTab].levels, pageByTabIndex[activeIndexTab].page || 1, pageByTabIndex[activeIndexTab].maxRowsPerPage || rowsPerPageOptions[0], pageByTabIndex[activeIndexTab]?.first || 0,  pageByTabIndex[activeIndexTab]?.sortField, pageByTabIndex[activeIndexTab]?.sortOrder, e.target.value)
            }}
            placeholder="Suche über alle Werte"
            size="50"
          />
          <DropdownLabeled
            label="Spalte"
            customClass="p-col-3"
            id="criterion"
            value={pageByTabIndex[activeIndexTab]?.searchCriterion || {name: "Name", value: "Name"}}//{columnDefinition[listTabContents[activeIndexTab].levels].}
            options={this.columnDefinition[listTabContents[activeIndexTab].levels]?.filter(col => col.sortField ).map(field => {return {name: field.sortField, value: field.sortField}})}
            onChange={(e) => {
              pageByTabIndex[activeIndexTab] = { ...pageByTabIndex[activeIndexTab], searchCriterion: e.value }
              this.setState({pageByTabIndex}) 
            }}
            optionLabel="name"
          /> */}
           <div className="p-grid">
              <DropdownLabeled
                 label="Selektionskriterium"
                 customClass="p-col-3"
                 id="criterion"
                 value={pageByTabIndex[activeIndexTab]?.searchCriterion || {name: this.columnDefinition[listTabContents[activeIndexTab].levels]?.[0].header, value: this.columnDefinition[listTabContents[activeIndexTab].levels]?.[0].sortField}}//{columnDefinition[listTabContents[activeIndexTab].levels].}
                 options={this.columnDefinition[listTabContents[activeIndexTab].levels]?.filter(col => col.searchCriterion ).map(field => {return {name: field.header, value: field.searchCriterion}})}
                 onChange={(e) => {
                   pageByTabIndex[activeIndexTab] = { ...pageByTabIndex[activeIndexTab], searchCriterion: e.value }
                   this.setState({pageByTabIndex}) 
                 }}
                 optionLabel="name"
              />
              <div className="p-col-3">
                <span style={{
                  fontSize: '12px',
                }}
                >
                  &nbsp;
                </span>
                <span className="p-float-label">
                  <InputText
                    value={this.state.pageByTabIndex[activeIndexTab]?.filter}
                    id="search-input"
                    type="search"
                    onInput={(e) => {
                      pageByTabIndex[activeIndexTab] = { ...pageByTabIndex[activeIndexTab], filter: e.target.value, page: 1, first: 0 } 
                      this.setState({ pageByTabIndex, loading: true })
                      clearTimeout(this.getDataTimeout); 
                      this.getDataTimeout = setTimeout(() => {
                        this.onPage(listTabContents[activeIndexTab].levels, pageByTabIndex[activeIndexTab].page, pageByTabIndex[activeIndexTab].maxRowsPerPage || rowsPerPageOptions[0], pageByTabIndex[activeIndexTab]?.first || 0,  pageByTabIndex[activeIndexTab]?.sortField, pageByTabIndex[activeIndexTab]?.sortOrder,pageByTabIndex[activeIndexTab]?.filter, pageByTabIndex[activeIndexTab]?.searchCriterion)
                      }, 1000); //debounce
                    }}
                    size="33"
                  />
                  <label htmlFor="search-input">Suchtext</label>
                </span>
              </div>
{/*               <OverlayPanel ref={(el) => { this.op = el; }} showCloseIcon dismissable>
              
                <p>Im Suchtext können Sie die Platzhalter '?' und '*'' benutzen:</p>
                <DataTable style={{ width: '48em' }} value={info}>
                  <Column style={{ width: '8em' }} field="character" header="Zeichen" />
                  <Column style={{ width: '20em' }} field="description" header="Beschreibung" />
                  <Column style={{ width: '20em' }} field="example" header="Beispiel" />
                </DataTable>
              </OverlayPanel>
              <div className="p-col-5">
                <Button
                  type="button"
                  id="info"
                  onClick={(e) => this.op.toggle(e)}
                  icon="pi pi-md-info-outline"
                />
                <Button
                  type="button"
                  id="search"
                  label="Suchen"
                  onClick={() => this.loadUserList(null, 'TOP', null, rowsPerPage)}
                />

                <Button
                  type="button"
                  id="clear"
                  className="p-button-primary"
                  label="Zurücksetzen"
                  onClick={() => this.clearSearch()}
                />
              </div> */}
            </div>
        </div>
        {listTabContents[0].breadcrumbs === ''
          ? <div className="p-col-2" style={{ textAlign: 'right' }} />
          : (
            <div className="p-col-2" style={{ textAlign: 'right' }}>
              <Button
                id="CSV"
                type="button"
                icon="pi-md-file-download"
                iconPos="left"
                label="CSV"
                onClick={this.export}
              />
            </div>
          )}
      </div>
    );

    if (statisticsList) {
      return (
        statisticsList.length === 0
          ? (
            <div>
              <Panel style={{ backgroundColor: '#F44336', color: 'white' }}>
                Fehler: Die Statistiken konnten nicht geladen werden.
              </Panel>
            </div>
          )
          : (
            <div>
              <div className="p-grid dashboard">
                {statisticsList.map((s, i) => (
                  <div id={s.name} key={i} className="p-col-12 p-md-2" onClick={() => this.handleClick(i)}>
                    <div className="overview-box overview-box-4">
                      <div className="overview-box-header" />
                      <div className="overview-box-content">
                        <div className="overview-box-icon"><i className="material-icons">assessment</i></div>
                        <div className="overview-box-title">{s.name}</div>
                        <div className="overview-box-count">{this.multiLanguage.returnInLanguage(s, 'de')}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <TabView
                activeIndex={activeIndexTab}
                onTabChange={(e) => this.setState({ 
                  activeIndexTab: e.index, 
                  //globalFilter: '', 
                  valueInputText: '', 
                })}
              >
                {listItemsOnTab.map((s2, i) => (
                  <TabPanel class="test" key={i} header={listTabContents[i].breadcrumbs}>
                    <div className="p-grid dashboard">
                      <div className="p-col-12">
                        <Card
                          header={this.cardHeader()}
                          style={{ height: '100%' }}
                          title={listTabContents[i].headings ? `${listTabContents[i].headings} - ${listTabContents[i].description}` : ''}
                        >
                          {listTabContents[i].levels !== 0 && listTabContents[i].levels !== 2 && header}
                          <DataTable
                            exportFilename={listTabContents[i].breadcrumbs}
                            sortField={
                              /* this.returnSortField(listTabContents[i].levels) */
                              this.state.pageByTabIndex[activeIndexTab]?.sortField || "Name"
                            }
                            sortOrder={this.state.pageByTabIndex[activeIndexTab]?.sortOrder || 1}
                            onSort={(e) => {
                              this.setState({ loading: true })
                              this.onPage(listTabContents[i].levels, this.state.pageByTabIndex[activeIndexTab].page || 1, this.state.pageByTabIndex[activeIndexTab].maxRowsPerPage || rowsPerPageOptions[0], this.state.pageByTabIndex[activeIndexTab]?.first || 0,  e.sortField, e.sortOrder, pageByTabIndex[activeIndexTab]?.filter, pageByTabIndex[activeIndexTab]?.searchCriterion)
                            }}
                            ref={(el) => { this.dt = el; }}
                            //globalFilter={globalFilter}
                            //header={header}
                            value={s2}
                            emptyMessage="Keine Daten geladen"
                            resizableColumns
                            paginator={listTabContents[i].levels > 0} 
                            lazy
                            loading={loading}
                            paginatorPosition="both"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            totalRecords={this.state.pageByTabIndex[activeIndexTab]?.potentialSelectionEntrySize || 0}
                            rowsPerPageOptions={rowsPerPageOptions}
                            first={this.state.pageByTabIndex[activeIndexTab]?.first || 0}
                            rows={this.state.pageByTabIndex[activeIndexTab]?.maxRowsPerPage || rowsPerPageOptions[0]}
                            onPage={(e) => {
                              const maxRows = this.state.pageByTabIndex[activeIndexTab]?.maxRowsPerPage || rowsPerPageOptions[0]
                              const newPage = (e.first + maxRows) / maxRows
                              this.setState({ loading: true })
                              this.onPage(listTabContents[i].levels, newPage, e.rows, e.first, this.state.pageByTabIndex[activeIndexTab].sortField, this.state.pageByTabIndex[activeIndexTab]?.sortOrder, this.state.pageByTabIndex[activeIndexTab]?.filter, pageByTabIndex[activeIndexTab]?.searchCriterion)
                            }}
                            expandedRows={this.state.expandedRows}
                            onRowExpand={(e) =>
                              this.viewProperties(e.data).then(
                                () => this.setState({ expandedRows: [e.data] }),
                              )}
                            onRowCollapse={() => this.setState({expandedRows: null})}
                            rowExpansionTemplate={() => this.renderPropertiesExpand(properties,
                              listTabContents[i].levels, eProperties, activeSaveDisabled)}
                          >
                            {this.renderMetaDataContentLines(
                              listTabContents[i].levels,
                              listTabContents[i].breadcrumbs
                                .substr(listTabContents[i].breadcrumbs.length - 3),
                            )}
                          </DataTable>
                        </Card>
                      </div>
                    </div>
                  </TabPanel>
                ))}
              </TabView>
            </div>
          )
      );
    }
    return <div />;
  }

  renderFooter() {
    return (
      <div>
        <Button id="yes" label="Ja" icon="pi pi-check" onClick={() => this.handleYes()} />
        <Button id="no" label="Nein" className="p-button-danger" icon="pi pi-times" onClick={() => this.onHide()} />
      </div>
    );
  }

  renderFooterSave() {
    return (
      <div>
        <Button id="save" label="Speichern" className="p-button-danger" icon="pi pi-check" onClick={() => this.handleSave()} />
        <Button id="cancel" label="Abbrechen" className="p-button-primary" icon="pi pi-times" onClick={() => this.handleCancel()} />
      </div>
    );
  }

  render() {
    const {
      statisticsList, listItemsOnTab, listTabContents,
      jsonProperties, visible, editVisible,
      activeIndexTab,
    } = this.state;
    const { properties } = jsonProperties;
    return (

      <div>
        <Dialog
          header="Lade Daten..."
          closable={false}
          closeOnEscape={false}
          visible={visible}
          modal
          onHide={() => this.setState({ visible: false })}
        >
          <ProgressSpinner />
        </Dialog>
        <Dialog
          header="Daten bearbeiten"
          footer={this.renderFooterSave()}
          style={{ width: '65%' }}
          closeOnEscape={false}
          visible={editVisible}
          modal
          onHide={() => this.setState({ editVisible: false })}
        >
          <Card>
            <div className="p-grid p-fluid">
              {this.dialogueList(activeIndexTab, properties, activeIndexTab)}
            </div>
          </Card>
        </Dialog>
        <Growl
          style={{ position: 'absolute', left: '78.5%', top: '345px' }}
          ref={(el) => { this.growl = el; }}
        />
        <div>{statisticsList.name}</div>
        <Card style={{ height: '100%' }}>
          {this.renderMetaDataContent(
            statisticsList, listItemsOnTab, listTabContents,
          )}
        </Card>
      </div>
    );
  }
}
